import angular from 'angular'
import component from './publishDate.component'

export default angular
  .module('ellipsis.publishDate', [])
  .component('publishDate', component)
